export default function accordion() {
  var acc = document.getElementsByClassName('accordion');
  var i;

  for (i = 0; i < acc.length; i++) {
    const item = acc[i];
    const heading = item.querySelector('h3');
    heading.addEventListener('click', () => {
        item.classList.toggle('active');

        [].forEach.call(
          acc,
          function(el) {
            if (el !== item) {
              el.classList.remove('active');
            }
          },
          this
        );
      });
  }
}
